import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, EMPTY, switchMap, throwError } from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const oidcSecurityService = inject(OidcSecurityService);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return oidcSecurityService.forceRefreshSession().pipe(
          switchMap(() => next(req)),
          catchError(() => {
            oidcSecurityService.authorize();
            return EMPTY;
          }),
        );
      }
      return throwError(() => error);
    }),
  );
};
